module.exports = __webpack_public_path__ + "static/dust-03faf93e1b7c16eb9e2200c5877bc8ce.mp4";